// @flow
import React from 'react';
// route
import { Link } from 'react-router-dom';
import { Checkbox } from 'material-ui';
// icons
import Visibility from 'material-ui/svg-icons/action/visibility';
import VisibilityOff from 'material-ui/svg-icons/action/visibility-off';

import { commit as CategoryEditMutation } from '../../mutations/CategoryEditMutation';
import { CharBadge } from '../ui/char-badge/char-badge';

import './categories.css';

type Props = {
	id: string,
	section: string,
	name: string,
	hidden: boolean,
	relay: Object,
	seoTitle: string,
	seoKeywords: string,
	seoDescription: string,
};

class CategoriesListItem extends React.PureComponent<Props> {
	changeInfo = (hidden?: boolean) => {
		const { relay, onUpdate, ...info } = this.props;
		const params = {
			...info,
			hidden: hidden !== undefined ? hidden : info.hidden,
		};

		CategoryEditMutation(relay.environment, params, (error, id) => {
			if (error) {
				console.log(error);
			}
			onUpdate();
		});
	};

	render() {
		const { seoTitle, seoKeywords, seoDescription, id, name, slug } = this.props;
		return (
			<div className="categories--item" id={id}>
				<Link to={`/category/${id}`} className="category--name">
					{name} slug {slug}
				</Link>
				<div style={{ gap: '5px', display: 'flex' }}>
					<Checkbox
						style={{ width: 24, height: 24, marginRight: -10 }}
						uncheckedIcon={<Visibility />}
						checkedIcon={<VisibilityOff />}
						onCheck={(e, v) => this.changeInfo(v)}
						checked={this.props.hidden}
					/>
					<CharBadge isActive={seoTitle}>З</CharBadge>
					<CharBadge isActive={seoDescription}>К</CharBadge>
					<CharBadge isActive={seoKeywords}>О</CharBadge>
				</div>
			</div>
		);
	}
}

export default CategoriesListItem;



// WEBPACK FOOTER //
// src/components/categories/CategoriesListItem.js